<template>
  <p class="modal_text error_message">
    <span v-show="afterSubmitErrorMsg" class="error_message_text">{{ afterSubmitErrorMsg }}</span>
  </p>
  <p>沒問題！請填寫會員帳號信箱，您將收到密碼重設說明</p>
  <form @submit="onSubmit">
    <div class="box_content form-group" :class="emailError?'error':''" data-name="forgetEmail">
      <label for="forgetEmail">請填寫您的會員帳號</label>
      <input type="email" class="form-control" id="forgetEmail" name="email" v-model="email" aria-describedby="emailHelp"
             placeholder="example@mail.com" @focus="inputFocusFunc" @blur="inputBlurFunc">
      <small id="emailHelp" class="form-text">{{ emailError }}</small>
    </div>
    <div class="modal_bottom">
      <div class="modal_btn_wrapper row">
        <div class="col-12">
          <button type="submit" class="btn primary lg" :disabled="!meta.valid || isSubmitting">
            <span class="btn_text">送出</span>
          </button>
        </div>
      </div>
      <div class="modal_btn_wrapper row">
        <div class="col-12">
          <button type="button" class="btn cancel lg" :disabled="isSubmitting" @click="hideLoginPanel">
            <span class="btn_text">取消</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {ref, inject} from "vue";
import {useForm, useField} from 'vee-validate';
import {forgetPost} from '@vuePath/api/login';
import {triggerErrorDialog, inputFocus, inputBlur} from '@vuePath/tools/tool';
import * as yup from 'yup';

export default {
  name: "ForgetForm",
  setup() {

    const hideLoginPanel = inject('hideLoginPanel');

    const schema = yup.object({
      email: yup.string().required("請輸入Email地址").email("格式錯誤，請再確認")
    });

    const {meta, handleSubmit, isSubmitting} = useForm({
      validationSchema: schema,
    });

    const {value: email, errorMessage: emailError} = useField('email');

    const afterSubmitErrorMsg = ref("");

    const onSubmit = handleSubmit(async values => {
      afterSubmitErrorMsg.value = "";

      await forgetPost(values.email)
          .then(res => {
            console.log(res);

            if (res.data.code === "000") {
              triggerErrorDialog('md', `重設密碼信件已寄出至${values.email}，請盡快重設您的密碼`, '確認', '', '成功寄出重設密碼信件', '');
              hideLoginPanel();
            } else {
              afterSubmitErrorMsg.value = '帳號不存在';
            }
          })
          .catch(function (err) {
            console.log(err);
          });
    });

    return {
      meta,
      email,
      emailError,
      onSubmit,
      isSubmitting,
      afterSubmitErrorMsg,
      hideLoginPanel
    };
  },
  methods: {
    inputFocusFunc(e) {
        inputFocus(e);
    },
    inputBlurFunc(e) {
        inputBlur(e);
    }
  }
}
</script>